<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>Configure Import Folders</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />
<div mat-dialog-content>
  <div class="guidance-access body-1">
    <div>
      EstImage can automatically search for quotes and invoices to import in a job, as well as for related images, from
      the folders selected below.
    </div>
    <div class="font-bold">Click "View Files" to give EstImage access.</div>
  </div>
  <div class="grid grid-cols-2 gap-x-20">
    <app-set-directory
      [data]="{ icon: 'folder_open', type: 'file', fileDirectory: fileDirectoryHandler()?.name }"
      (setDirectory)="setDirectoryHandler($event)"
      (deleteDirectory)="deleteDirectoryHandler($event)"></app-set-directory>
    <app-set-directory
      [data]="{ icon: 'crop_original', type: 'image', imageDirectory: imagesDirectoryHandler()?.name }"
      (setDirectory)="setDirectoryHandler($event)"
      (deleteDirectory)="deleteDirectoryHandler($event)"></app-set-directory>
  </div>
</div>
<mat-divider class="mx-20!" />
<mat-dialog-actions>
  <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
  <button matButton="elevated" class="red-button" cdkFocusInitial (click)="saveHandlers()">SAVE</button>
</mat-dialog-actions>
